/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Test_DescriptionInputs */

const en_admin_settings_test_description = /** @type {(inputs: Admin_Settings_Test_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run a live request with your current saved config. No orders or data are persisted.`)
};

/**
* | output |
* | --- |
* | "Run a live request with your current saved config. No orders or data are persisted." |
*
* @param {Admin_Settings_Test_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_test_description = /** @type {((inputs?: Admin_Settings_Test_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Test_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_test_description(inputs)
});
export { admin_settings_test_description as "admin.settings.test.description" }